import { render, staticRenderFns } from "./TheNavbarVertical.vue?vue&type=template&id=56246e26"
import script from "./TheNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheNavbarVertical.vue?vue&type=script&lang=js"
import style0 from "./TheNavbarVertical.vue?vue&type=style&index=0&id=56246e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports